import { render, staticRenderFns } from "./SalesCustomerDetail.vue?vue&type=template&id=38c66661&scoped=true"
import script from "./SalesCustomerDetail.vue?vue&type=script&lang=js"
export * from "./SalesCustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./SalesCustomerDetail.vue?vue&type=style&index=0&id=38c66661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c66661",
  null
  
)

export default component.exports